import { viderBrouillon } from '@/lib/brouillon';
import { Icon } from '@pms-digital/design-system';
import { Link } from '@tanstack/react-router';

/**
 * The first cell of the grid: an empty card with a dashed `gray-300` frame, as tall as the
 * others, that starts a new text (it empties the draft, then opens the input screen).
 */
export function CarteNouveauTexte() {
  return (
    <Link
      to="/"
      onClick={viderBrouillon}
      className="flex min-h-[196px] flex-1 flex-col items-center justify-center gap-2 rounded-md border-2 border-gray-300 border-dashed bg-white px-6 py-4 text-gray-700 no-underline transition-colors hover:border-bleu-nuit hover:bg-gray-50 hover:text-gray-700"
    >
      <Icon name="add" size={32} />
      <span className="font-semibold text-body text-black leading-[1.4]">nouveau texte</span>
    </Link>
  );
}
